import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Breadcrumbs.css';

const ROUTE_LABELS = {
  about: 'About Us',
  residential: 'Residential Construction',
  commercial: 'Commercial Construction',
  gallery: 'Project Gallery',
  services: 'Our Services',
  contact: 'Contact Us',
  usilampatti: 'Usilampatti Construction',
  karaikudi: 'Karaikudi Construction',
  sivaganga: 'Sivaganga Construction',
  thiruppuvanam: 'Thiruppuvanam Construction',
  theni: 'Theni Construction',
  location: 'Service Locations'
};

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  if (location.pathname === '/') return null;

  return (
    <nav className="breadcrumbs" aria-label="breadcrumb">
      <div className="container">
        <ul itemScope itemType="https://schema.org/BreadcrumbList">
          <li
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <Link to="/" itemProp="item">
              <span itemProp="name">Home</span>
            </Link>
            <meta itemProp="position" content="1" />
          </li>
          {pathnames.map((value, index) => {
            const last = index === pathnames.length - 1;
            const to = `/${pathnames.slice(0, index + 1).join('/')}`;
            const keyLower = value.toLowerCase();
            const displayName =
              ROUTE_LABELS[keyLower] ||
              value.charAt(0).toUpperCase() + value.slice(1).replace(/-/g, ' ');

            return last ? (
              <li
                key={to}
                className="active"
                aria-current="page"
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <span itemProp="name">{displayName}</span>
                <meta itemProp="position" content={String(index + 2)} />
              </li>
            ) : (
              <li
                key={to}
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <Link to={to} itemProp="item">
                  <span itemProp="name">{displayName}</span>
                </Link>
                <meta itemProp="position" content={String(index + 2)} />
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default Breadcrumbs;
